export const getDefault = () => {
  const schema = {
    name: 'SubWebSchedule',
    title: 'Horário de atendimento',
    subTitle: '',
    description: '',
    isClosed: false,
    typeMode: 'both',
    href: 'https://www.ua.pt',
    action: {
      show: false,
      text: 'Mais informações',
      href: 'https://www.ua.pt'
    },
    data: [
      {
        title: 'atendimento presencial',
        subTitle: '10h00 às 18h00',
        description: ' segunda a sexta',
        content: 'Encerra das 12:30 ás 14h. \nLocal: [departamento de matemática](https://www.ua.pt)'
      },
      {
        title: 'atendimento telefónico',
        subTitle: '10h00 às 17h30',
        description: ' segunda a sexta',
        content: 'contacto: [email](exemplo@ua.pt)'
      }
    ],
    editor: {
      localService: {
        startHour: '10:00',
        endHour: '17:00',
        startWeekDay: 'segunda',
        endWeekDay: 'sexta',
        content: 'Encerra das 12:30 ás 14h. \nLocal: [departamento de matemática](https://www.ua.pt)'
      },
      phoneService: {
        startHour: '10:00',
        endHour: '17:30',
        startWeekDay: 'segunda',
        endWeekDay: 'sexta',
        phone: '234 324 435',
        other: 'contacto: [email](exemplo@ua.pt)'
      },
      text: {
        column1: 'O serviço encontra-se em atendimento condicionado devido à COVID-19 ',
        column2: 'Para mais informações: 234 324 435'
      }
    }
  }
  return schema
}
